import { gql } from '@apollo/client';

export const PUSH_DSP_TASK = gql`
    mutation PushDspTask($request: PushDspTaskRequestInput!) {
        pushDspTask(request: $request)
    }
`;

export interface PushDspTaskRequestInput {
    batchNumbers?: string[] | null;
    areaIds?: number[] | null;
    taskDate?: string | null;
    warehouseId?: number | null;
    operatorId?: number | null;
    operatorName?: string | null;
}

export interface PushDspTaskResponse {
    pushDspTask: boolean;
}

export interface PushDspTaskVariables {
    request: PushDspTaskRequestInput;
}
